import styles from './Unauthorized.module.scss'

const UnauthorizedBox = () => {
  return <div className={styles.container}>
    <h4>לא מחובר</h4>
    <h3>אנא פנה למנהל לצורך הדרכה על אופן הכניסה למערכת</h3>
  </div>
}
export default UnauthorizedBox
